import React, { memo, useMemo } from 'react';
import buildClassName from 'js/utils/classNameBuilder.util';
import { areOmitedPropsEqual } from 'js/utils/methods.util';

import { TableRow } from '../TableRow';

import style from './TableHeaderRow.scss';

export const arePropsEqual = (prevProps, nextProps) => {
    return areOmitedPropsEqual(prevProps, nextProps, ['cells'])
        && prevProps.cells?.length === nextProps.cells?.length;
};

export const TableHeaderRow = memo(({ cells = [], classNames }) => {
    const headerRowClassNames = useMemo(() => ({
        ...classNames,
        tableRowColumn: buildClassName(['tableHeaderRowColumn'], style, classNames),
        tableRowContainer: `${buildClassName(['tableHeaderRowContainer'], style, classNames)} cms-table-header-row-container`
    }), [classNames]);

    return <TableRow cells={cells} classNames={headerRowClassNames} />;
}, arePropsEqual);
